import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';
import { SalaryHistoryDbType } from '../../../../api/types/accountants/salary-history/salary-history.type';

export const getSalaryHistoryOperations = async (
  startDate: Date,
  endDate: Date,
  setSalariesData: (items: SalaryHistoryDbType[]) => any,
) => {
  try {
    const res = await appApi.getSalaryHistory(startDate, endDate);
    setSalariesData(res.data.body);
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
